module.exports = __webpack_public_path__ + "img/brand-15.b80fbc23.png";